export default "Lav jeres egne simple trommer og spil fede rytmer!";